import { createFileRoute } from '@tanstack/react-router';
import { VenuesPage } from '../../features/venues/VenuesPage.jsx';

export const Route = createFileRoute('/_app/venues/')({ component: VenuesPage });
